import awsAcctService from '@/services/awsacct.service.js'
import masterpayerService from '@/services/masterpayer.service.js'


export default {
  getAllMasterpayerRequest: context=>{
    console.log('getting all mP')
    context.commit('setMasterpayerListLoading', true)
    masterpayerService.getMasterpayerRequest(null, (err,res) => {
      if(err){
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 20000,
            message: err.message
          },
          { root: true }
        )
      } else {
        context.commit('setMasterpayerRequest', res)
      }
      context.commit('setMasterpayerListLoading', false)
    })
  },

  getMasterpayerRequestDetail: (context, id) => {
    context.commit('setMasterpayerRequestDetailLoading', true)
    masterpayerService.getMasterpayerRequest(id, (err,res) => {
      if(err){
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 20000,
            message: err
          },
          { root: true }
        )
        
        vm.$router.push({ path: `/admin/onboard-masterpayer/view-request` })

      } else {
        context.commit('setMasterpayerRequestDetail', res)
        context.commit('setMasterpayerRequestDetailLoading', false)
      }
      
    })
  },


  setMasterpayerStatus: (context, data) => {
    context.commit('setMasterpayerStatusLoading', true)
    masterpayerService.setMasterpayerStatus(data, (err,res) => {
      if(err){
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 20000,
            message: err
          },
          { root: true }
        )
      } else {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'success',
            timeout: 2000,
            message: 'Successfully updated Masterpayer Request'
          },
          { root: true }
        )
        context.commit('setMasterpayerStatusLoading', false)
      }
      
    })
  },


  saveNewMasterpayerRequest: (context, data) => {
    context.commit('setMasterpayerStatusLoading', true)
    masterpayerService.masterpayerSubmit(data, (err,res) => {
      if(err){
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 20000,
            message: err
          },
          { root: true }
        )
      } else {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'success',
            timeout: 2000,
            message: 'Successfully Created New Masterpayer Request'
          },
          { root: true }
        )
        context.commit('setMasterpayerStatusLoading', false)
      }
      
    })
  },
}